export enum RequestType {
	drm = 'drm',
	cdn = 'cdn',
}
